import discardAppearanceOption from './data/mutators/discardAppearanceOption';
import saveAppearanceOption from './orchestration/saveAppearanceOption';
import isAppearanceOptionDirty from './utils/isAppearanceOptionDirty';
import AppearanceFull from './view/AppearanceFull';
import AppearanceQuick from './view/AppearanceQuick';
import { Option, QuickSettingOrder } from 'owa-options-core';
import { OwaWorkload } from 'owa-workloads';
import * as React from 'react';

let AppearanceOption: Option = {
    key: 'appearance',
    titleStringKey: 'optionTitle_appearance',
    searchTermsStringKey: 'optionSearch_appearance',
    fullOptionFormSettings: {
        render: () => <AppearanceFull />,
        isDirty: isAppearanceOptionDirty,
        onSave: saveAppearanceOption,
        onDiscard: discardAppearanceOption,
    },
    quickOptionSettings: {
        rendering: {
            render: () => <AppearanceQuick />,
        },
        getOrder: () => QuickSettingOrder.CalendarAppearance,
        workloads: OwaWorkload.Calendar,
        customTitle: 'options_appearance_weekstartdayQuickSettingLabel',
    },
    allowedOptionKeys: ['CalendarAppearance'],
};

export default AppearanceOption;
